var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lab-task',[_c('lab-density-of-water',{attrs:{"salt-concentration":_vm.saltConcentrationValue}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }